import { Roles } from "@/enums/roles.enum";
import { api } from "@/lib/api";

export interface UserDTO {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  role: Roles;
  superAdmin: boolean;
}
export interface SignupRequestDto {
  token: string;
  firstName: string;
  lastName: string;
  companyName: string;
  password: string;
  projectId?: string;
}

export interface LoginResponse {
  token: string;
  user: UserDTO;
}
export interface ForgotPasswordResponse {
  message: string;
}

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>("/users/login", {
      email,
      password,
    });
    return response.data;
  },
  forgetPassword: async (email: string): Promise<ForgotPasswordResponse> => {
    const response = await api.post<ForgotPasswordResponse>(
      "/users/forgot-password",
      {
        email,
      }
    );
    return response.data;
  },
  resetPassword: async (
    password: string,
    token: string
  ): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(
      `/users/reset-password?token=${token}`,
      {
        password,
      }
    );
    return response.data;
  },
  signup: async (data: SignupRequestDto): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>("/signup/complete", data);
    return response.data;
  },
};
